import api from './api';

const configService = {
  /**
   * Get all system configurations accessible to the current user
   */
  getSystemConfigs: async () => {
    const response = await api.get('/system-configs/');
    return response.data;
  },

  /**
   * Update a specific configuration by ID
   */
  updateSystemConfig: async (id, data) => {
    const response = await api.patch(`/system-configs/${id}/`, data);
    return response.data;
  }
};

export default configService;
